// Reference:
// * https://github.com/epicweb-dev/epic-stack/blob/90ef60d4b2e762a1888fc72abd71f40a5142f978/app/routes/resources+/theme-switch.tsx

import { getFormProps, useForm } from "@conform-to/react";
import { useFetcher } from "react-router";
import { ServerOnly } from "remix-utils/server-only";

import { useRequestInfo } from "@/utils/request-info";

import { useOptimisticThemeMode, useTheme } from "./theme";
import { ThemeControlButtons } from "./theme-control-buttons";

interface ThemeControlProps {
  className?: string;
}

export function ThemeControl({ className }: ThemeControlProps) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const requestInfo = useRequestInfo();
  const currentTheme = useTheme();
  const optimisticMode = useOptimisticThemeMode();
  const fetcher = useFetcher();
  const [form] = useForm({
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,
                                @typescript-eslint/no-unsafe-member-access
    */
    lastResult: fetcher.data?.result,
  });

  const isSystem =
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    (optimisticMode ?? requestInfo.userPreference.theme ?? "system") ===
    "system";

  return (
    <fetcher.Form
      method="POST"
      {...getFormProps(form)}
      action="/theme"
      aria-label="Theme control"
      className="flex gap-3"
    >
      <ServerOnly>
        {() => (
          /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,
                                      @typescript-eslint/no-unsafe-member-access
          */
          <input name="redirectTo" type="hidden" value={requestInfo.path} />
        )}
      </ServerOnly>

      <ThemeControlButtons
        className={className}
        currentTheme={currentTheme}
        isSystem={isSystem}
      />
    </fetcher.Form>
  );
}
